/**
 * Module Category Definitions
 * These categories are used to classify training modules in the Etasha system.
 * This file mirrors the backend constants for consistency.
 */

export const MODULE_CATEGORIES = {
  'SE': { name: 'SE', label: 'Spoken English', color: '#6366f1' },
  'WOW': { name: 'WOW', label: 'World of Work', color: '#ec4899' },
  'I': { name: 'I', label: 'Inter & Intrapersonal Skills', color: '#10b981' },
  'IT': { name: 'IT', label: 'Computer & Internet Usage', color: '#06b6d4' },
  'CSS': { name: 'CSS', label: 'Customer Service and Sales', color: '#f59e0b' },
  'SC': { name: 'SC', label: 'Social Confidence', color: '#8b5cf6' },
  'TY': { name: 'TY', label: 'Tally ERP 9', color: '#14b8a6' },
  'AC': { name: 'AC', label: 'Accounts', color: '#f97316' },
  'BFSI': { name: 'BFSI', label: 'Banking & Finance', color: '#ef4444' }
};

// Array of category values for dropdowns
export const CATEGORY_OPTIONS = Object.entries(MODULE_CATEGORIES).map(([code, data]) => ({
  value: code,
  label: `${code} - ${data.label}`,
  color: data.color
}));

// Get category display label
export const getCategoryLabel = (categoryCode) => {
  return MODULE_CATEGORIES[categoryCode]?.label || categoryCode;
};

// Get category color for UI badges
export const getCategoryColor = (categoryCode) => {
  return MODULE_CATEGORIES[categoryCode]?.color || '#6b7280';
};

// Program frameworks are defined by their length in weeks (program.framework_weeks).
// Adding a new duration is data entry — no code change here.

// Badge label, e.g. 14 -> "14-week framework".
export const getFrameworkLabel = (weeks) => {
  return weeks ? `${weeks}-week framework` : '—';
};

// Badge color, bucketed by length so shorter/longer frameworks read distinctly.
export const getFrameworkColor = (weeks) => {
  if (!weeks) return '#6b7280';
  if (weeks <= 5) return '#10b981';   // ~1 month
  if (weeks <= 9) return '#6366f1';   // ~2 months
  return '#8b5cf6';                   // 3 months and longer
};
